module.exports = __webpack_public_path__ + "img/a4e44c6.png";